import * as types from './mutationsType.js';

export const state = {
  loading: false,
  userInfo: {},
  fileList: [],
};

export const mutations = {
  [types.SET_LOADING](state, value) {
    state.loading = value;
  },
  [types.SET_FILE_LIST](state, value) {
    state.loading = false;
    state.fileList = value;
  },
  [types.SET_USER_INFO](state, value) {
    state.loading = false;
    state.userInfo = value;
  },
};
